export default {
  BusinessReportStockDeliver: {
    deliveryTime: 'Delivery time',
    warehouseIds: 'Warehouse',
    logisticsCompanyIds: 'Logistics provider',
    subtotal: 'Subtotal',
    shippingQty: 'Number of shipments',
    packageQty: 'Number of packages',
    goodsQty: 'Number of items shipped',
    postageTotal: 'Total freight charges',
    collectTypeOptions1: 'By warehouse',
    collectTypeOptions2: 'By logistics provider',
    total: 'Total'
  }
};
